import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Logger } from 'projects/common/src/app/classes';
import { AuthenticationService } from 'src/app/services/authentication';
import { NavigationService } from 'src/app/modules/core/services/navigation.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CanActiveLoginService extends Logger implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private navigationService: NavigationService,
    private router: Router
  ) {
    super();
  }

  /**
   * CanDeactivate
   */
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const result = this.authService.isAuth();
    if (result) {
      this.router.navigate([environment.homePath]);

      /*
      TODO: Volver a la página que se tenía antes de botar la sesión
      const prevView = this.navigationService.prevUrl();
      if (prevView && prevView !== '/') {
        this.router.navigate(prevView.split('/'));
      }
      */
    }
    return true;
  }
}
